import { DOMParser } from '@xmldom/xmldom';

export type Type = "text" | "separator" | "numeric" | "fieldset"

export type DynamicElement<T extends Type, O> = {
    fieldReference: string;
    name: string;
    type: T;
    value_i18n: Obj_i18n<O>;
}
export type DynamicElementSome = DynamicElement<any, any>
export type DynamicElementText = DynamicElement<"text", string>
export type DynamicElementNumber = DynamicElement<"numeric", number>
export type DynamicElementFieldset = DynamicElement<"fieldset", Record<string, DynamicElementSome>>

export type SomeValue = string | number
export type SomeOutputType = Record<string,
    | SomeValue
    | { [key: string]: SomeOutputType }
    | SomeOutputType[]
>
export type WebContentValue = string | number | { [key: string]: WebContentValue }
export type WebContentValues = Record<string, WebContentValue | WebContentValue[] | { [key: string]: WebContentValues }>

export function parseWebContent(xml: string): WebContentValues {

    try {
        const content = new DOMParser().parseFromString(xml, 'application/xml');
        const nodes = Array.from(content.documentElement.childNodes) as Element[];
        const directChildren = nodes.filter(e => e.nodeName == "dynamic-element" && (e.parentNode as Element | null)?.tagName == "root")
        return parseDynamicElements(directChildren)

    } catch (error) {
        console.error(error);
        return {};
    }
}


export function parseDynamicElements(elements: Array<Element>): WebContentValues {
    const fields = elements.reduce((acc: Record<string, Array<Element>>, element) => {
        let field_ref = element.getAttribute("field-reference")
        if (!field_ref) return acc
        if (!(field_ref in acc)) {
            acc[field_ref] = []

        }
        acc[field_ref].push(element)
        return acc
    }, {})

    const result: any = {}
    for (let field_ref in fields) {
        if (fields[field_ref].length == 1) {
            result[field_ref] = parseDynamicElement(fields[field_ref][0])
        }
        else {
            result[field_ref] = fields[field_ref].map(parseDynamicElement)
        }
    }
    return result

}

export function parseDynamicElement(element: Element): WebContentValue | WebContentValues {
    const type = element.getAttribute("type") as Type | string | null
    if (type == "text") {
        const x = element.getElementsByTagName('dynamic-content').item(0);
        if (x) return x.textContent || '';
        return ""
    }

    if (type == "numeric") {
        const x = element.getElementsByTagName('dynamic-content').item(0);
        if (x) return Number(x.textContent);
        return 0
    }

    // Liferay date field
    if (type == "date") {
        const x = element.getElementsByTagName('dynamic-content').item(0);
        if (x) return x.textContent || '';
        return ""
    }

    // Liferay image field
    if (type == "image") {
        const x = element.getElementsByTagName('dynamic-content').item(0);
        if (!x) return "";
        const raw = x.textContent || '';
        try {
            const parsed = JSON.parse(raw);
            return parsed as any;
        } catch {
            return raw;
        }
    }

    if (type == "fieldset") {
        const nodes = Array.from(element.childNodes) as Element[];
        const directChildren = nodes.filter(e => e.nodeName == "dynamic-element")
        return parseDynamicElements(directChildren)
    }
    return ""
}